import { defineAsyncComponent } from 'vue';

const IconAction = defineAsyncComponent(() => import('./Action.vue'));
const IconAccount = defineAsyncComponent(() => import('./Account.vue'));
const IconAdd = defineAsyncComponent(() => import('./Add.vue'));
const IconAdd2 = defineAsyncComponent(() => import('./Add2.vue'));
const IconAddToCart = defineAsyncComponent(() => import('./AddToCart.vue'));
const IconAdRequest = defineAsyncComponent(() => import('./AdRequest.vue'));
const IconAdSpend = defineAsyncComponent(() => import('./AdSpend.vue'));
const IconAdvancedReport = defineAsyncComponent(() => import('./AdvancedReport.vue'));
const IconAdvertiser = defineAsyncComponent(() => import('./Advertiser.vue'));
const IconAfter = defineAsyncComponent(() => import('./After.vue'));

const IconAirplane = defineAsyncComponent(() => import('./Airplane.vue'));
const IconAirTravel = defineAsyncComponent(() => import('./AirTravel.vue'));
const IconAlert = defineAsyncComponent(() => import('./Alert.vue'));
const IconApplyAll = defineAsyncComponent(() => import('./ApplyAll.vue'));
const IconApprove = defineAsyncComponent(() => import('./Approve.vue'));
const IconArrival = defineAsyncComponent(() => import('./Arrival.vue'));

const IconArrowDown = defineAsyncComponent(() => import('./ArrowDown.vue'));
const IconArrowUp = defineAsyncComponent(() => import('./ArrowUp.vue'));
const IconAuction = defineAsyncComponent(() => import('./Auction.vue'));
const IconAudience = defineAsyncComponent(() => import('./Audience.vue'));
const IconAudienceAudit = defineAsyncComponent(() => import('./AudienceAudit.vue'));
const IconAudienceFile = defineAsyncComponent(() => import('./AudienceFile.vue'));
const IconAudienceGeofenceGroup = defineAsyncComponent(() => import('./AudienceGeofenceGroup.vue'));
const IconAudienceLogic = defineAsyncComponent(() => import('./AudienceLogic.vue'));
const IconAudienceRule = defineAsyncComponent(() => import('./AudienceRule.vue'));
const IconAudit = defineAsyncComponent(() => import('./Audit.vue'));
const IconAuditCreated = defineAsyncComponent(() => import('./auditTrail/Created.vue'));
const IconAuditDeleted = defineAsyncComponent(() => import('./auditTrail/Deleted.vue'));
const IconAuditUpdated = defineAsyncComponent(() => import('./auditTrail/Updated.vue'));
const IconAutopilot = defineAsyncComponent(() => import('./Autopilot.vue'));
const IconAvails = defineAsyncComponent(() => import('./Avails.vue'));
const IconBadConnection = defineAsyncComponent(() => import('./BadConnection.vue'));
const IconBefore = defineAsyncComponent(() => import('./Before.vue'));
const IconBudget = defineAsyncComponent(() => import('./Budget.vue'));
const IconBudgetCap = defineAsyncComponent(() => import('./BudgetCap.vue'));
const IconBuy = defineAsyncComponent(() => import('./Buy.vue'));
const IconBuyer = defineAsyncComponent(() => import('./Buyer.vue'));
const IconCadenceBuy = defineAsyncComponent(() => import('./CadenceBuy.vue'));
const IconCalendar = defineAsyncComponent(() => import('./Calendar.vue'));
const IconCampaign = defineAsyncComponent(() => import('./Campaign.vue'));
const IconCancel = defineAsyncComponent(() => import('./Cancel.vue'));
const IconCart = defineAsyncComponent(() => import('./Cart.vue'));
const IconChartArea = defineAsyncComponent(() => import('./chart-types/Area.vue'));
const IconChartBar = defineAsyncComponent(() => import('./chart-types/Bar.vue'));
const IconChartCandlestick = defineAsyncComponent(() => import('./chart-types/Candlestick.vue'));
const IconChartLine = defineAsyncComponent(() => import('./chart-types/Line.vue'));
const IconChartPie = defineAsyncComponent(() => import('./chart-types/Pie.vue'));
const IconCheck = defineAsyncComponent(() => import('./Check.vue'));
const IconCheck2 = defineAsyncComponent(() => import('./Check2.vue'));
const IconCheckAvailsResultSuccess = defineAsyncComponent(() => import('./CheckAvailsResultSuccess.vue'));
const IconCheckAvailsResultFailure = defineAsyncComponent(() => import('./CheckAvailsResultFailure.vue'));
const IconCheckboxChecked = defineAsyncComponent(() => import('./CheckboxChecked.vue'));
const IconCheckboxUnchecked = defineAsyncComponent(() => import('./CheckboxUnchecked.vue'));
const IconCheckboxUndeterminated = defineAsyncComponent(() => import('./CheckboxUndeterminated.vue'));
const IconChecked = defineAsyncComponent(() => import('./Checked.vue'));
const IconCheckFat = defineAsyncComponent(() => import('./CheckFat.vue'));
const IconCircle = defineAsyncComponent(() => import('./Circle.vue'));
const IconCircleCheck = defineAsyncComponent(() => import('./CircleCheck.vue'));
const IconCircleX = defineAsyncComponent(() => import('./CircleX.vue'));
const IconCity = defineAsyncComponent(() => import('./City.vue'));
const IconClock = defineAsyncComponent(() => import('./Clock.vue'));
const IconClose = defineAsyncComponent(() => import('./Close.vue'));
const IconCo2 = defineAsyncComponent(() => import('./Co2.vue'));
const IconCollapse = defineAsyncComponent(() => import('./Collapse.vue'));
const IconCollapsed = defineAsyncComponent(() => import('./Collapsed.vue'));
const IconCollapsed2 = defineAsyncComponent(() => import('./Collapsed2.vue'));
const IconCollapseNavBar = defineAsyncComponent(() => import('./CollapseNavBar.vue'));
const IconColumns = defineAsyncComponent(() => import('./Columns.vue'));
const IconCopy = defineAsyncComponent(() => import('./Copy.vue'));
const IconCountry = defineAsyncComponent(() => import('./Country.vue'));
const IconCPM = defineAsyncComponent(() => import('./CPM.vue'));
const IconCreative = defineAsyncComponent(() => import('./Creative.vue'));
const IconCreativeType = defineAsyncComponent(() => import('./CreativeType.vue'));
const IconCsvFile = defineAsyncComponent(() => import('./CsvFile.vue'));
const IconCurator = defineAsyncComponent(() => import('./Curator.vue'));
const IconCurrency = defineAsyncComponent(() => import('./Currency.vue'));
const IconCustomField = defineAsyncComponent(() => import('./CustomField.vue'));
const IconDailyGoalCap = defineAsyncComponent(() => import('./DailyGoalCap.vue'));
const IconDashboard = defineAsyncComponent(() => import('./Dashboard.vue'));
const IconDaypart = defineAsyncComponent(() => import('./Daypart.vue'));
const IconDeal = defineAsyncComponent(() => import('./Deal.vue'));
const IconDelete = defineAsyncComponent(() => import('./Delete.vue'));
const IconDemand = defineAsyncComponent(() => import('./Demand.vue'));

const IconDeparture = defineAsyncComponent(() => import('./Departure.vue'));
const IconDisplayAndVideo = defineAsyncComponent(() => import('./DisplayAndVideo.vue'));
const IconDiscount = defineAsyncComponent(() => import('./Discount.vue'));
const IconDooh = defineAsyncComponent(() => import('./DOOH.vue'));
const IconDown = defineAsyncComponent(() => import('./Down.vue'));
const IconDownload = defineAsyncComponent(() => import('./Download.vue'));
const IconDrag = defineAsyncComponent(() => import('./Drag.vue'));
const IconDraw = defineAsyncComponent(() => import('./Draw.vue'));
const IconDuplicate = defineAsyncComponent(() => import('./Duplicate.vue'));
const IconEdit = defineAsyncComponent(() => import('./Edit.vue'));
const IconEditable = defineAsyncComponent(() => import('./Editable.vue'));
const IconEmail = defineAsyncComponent(() => import('./Email.vue'));
const IconEmail2 = () => import('./Email2.vue');
const IconEmailAlert = defineAsyncComponent(() => import('./EmailAlert.vue'));
const IconEnlarge = defineAsyncComponent(() => import('./Enlarge.vue'));
const IconError = defineAsyncComponent(() => import('./Error.vue'));
const IconErrorFilled = defineAsyncComponent(() => import('./ErrorFilled.vue'));
const IconEstimatedCPM = defineAsyncComponent(() => import('./EstimatedCPM.vue'));
const IconEvent = defineAsyncComponent(() => import('./Event.vue'));
const IconExchange = defineAsyncComponent(() => import('./Exchange.vue'));
const IconExcluded = defineAsyncComponent(() => import('./Excluded.vue'));
const IconExitFullScreen = defineAsyncComponent(() => import('./ExitFullScreen.vue'));
const IconExpand = defineAsyncComponent(() => import('./Expand.vue'));
const IconExpanded = defineAsyncComponent(() => import('./Expanded.vue'));
const IconExpanded2 = defineAsyncComponent(() => import('./Expanded2.vue'));
const IconExpandNavBar = defineAsyncComponent(() => import('./ExpandNavBar.vue'));
const IconExternalCreative = defineAsyncComponent(() => import('./ExternalCreative.vue'));
const IconExternalEvent = defineAsyncComponent(() => import('./ExternalEvent.vue'));
const IconEye = defineAsyncComponent(() => import('./Eye.vue'));
const IconFallbackCreative = defineAsyncComponent(() => import('./FallbackCreative.vue'));
const IconFast = defineAsyncComponent(() => import('./Fast.vue'));
const IconFastForward = defineAsyncComponent(() => import('./FastForward.vue'));
const IconFees = defineAsyncComponent(() => import('./Fees.vue'));
const IconFileCSV = defineAsyncComponent(() => import('./FileCSV.vue'));
const IconFileSync = defineAsyncComponent(() => import('./FileSync.vue'));
const IconFileXLS = defineAsyncComponent(() => import('./FileXLS.vue'));
const IconFilter = defineAsyncComponent(() => import('./Filter.vue'));
const IconFilterFilled = defineAsyncComponent(() => import('./FilterFilled.vue'));
const IconFitIntoView = defineAsyncComponent(() => import('./FitIntoView.vue'));
const IconFlightArrival = defineAsyncComponent(() => import('./FlightArrival.vue'));
const IconFlightDeparture = defineAsyncComponent(() => import('./FlightDeparture.vue'));
const IconFlowChart = defineAsyncComponent(() => import('./FlowChart.vue'));
const IconForecast = defineAsyncComponent(() => import('./Forecast.vue'));
const IconFormula = defineAsyncComponent(() => import('./Formula.vue'));
const IconFullScreen = defineAsyncComponent(() => import('./FullScreen.vue'));
const IconGeofenceGroup = defineAsyncComponent(() => import('./GeofenceGroup.vue'));
const IconGood = defineAsyncComponent(() => import('./Good.vue'));
const IconGoodFilled = defineAsyncComponent(() => import('./GoodFilled.vue'));
const IconGroup = defineAsyncComponent(() => import('./Group.vue'));
const IconHeaderBidderPreset = defineAsyncComponent(() => import('./YieldManagerConfig.vue'));
const IconHelp = defineAsyncComponent(() => import('./Help.vue'));
const IconHide = defineAsyncComponent(() => import('./Hide.vue'));
const IconHierarchy = defineAsyncComponent(() => import('./Pie.vue'));
const IconHigh = defineAsyncComponent(() => import('./High.vue'));
const IconImpressions = defineAsyncComponent(() => import('./Impressions.vue'));
const IconImpressionsDelivered = defineAsyncComponent(() => import('./ImpressionsDelivered.vue'));
const IconInfinity = defineAsyncComponent(() => import('./Infinity.vue'));
const IconInfo = defineAsyncComponent(() => import('./Info.vue'));
const IconJourney = defineAsyncComponent(() => import('./Journey.vue'));
const IconLanguage = defineAsyncComponent(() => import('./Language.vue'));
const IconLeaf = defineAsyncComponent(() => import('./Leaf.vue'));
const IconLegacy = defineAsyncComponent(() => import('./Legacy.vue'));
const IconLiftDashboard = defineAsyncComponent(() => import('./LiftDashboard.vue'));
const IconLightBulb = defineAsyncComponent(() => import('./LightBulb.vue'));
const IconLightning = defineAsyncComponent(() => import('./Lightning.vue'));
const IconLineItem = defineAsyncComponent(() => import('./LineItem.vue'));
const IconLink = defineAsyncComponent(() => import('./Link.vue'));
const IconList = defineAsyncComponent(() => import('./List.vue'));
const IconLocation = defineAsyncComponent(() => import('./Location.vue'));
const IconLocation2 = defineAsyncComponent(() => import('./Location2.vue'));
const IconLock = defineAsyncComponent(() => import('./Lock.vue'));
const IconLocked = defineAsyncComponent(() => import('./Locked.vue'));
const IconLogout = defineAsyncComponent(() => import('./Logout.vue'));
const IconLow = defineAsyncComponent(() => import('./Low.vue'));
const IconMailbox = defineAsyncComponent(() => import('./Mailbox.vue'));
const IconMagicWand = defineAsyncComponent(() => import('./MagicWand.vue'));
const IconMap = defineAsyncComponent(() => import('./Map.vue'));
const IconMargin = defineAsyncComponent(() => import('./Margin.vue'));
const IconMarket = defineAsyncComponent(() => import('./Market.vue'));
const IconMarketplace = defineAsyncComponent(() => import('./Marketplace.vue'));
const IconMarkup = defineAsyncComponent(() => import('./Markup.vue'));
const IconMaster = defineAsyncComponent(() => import('./Master.vue'));
const IconMaxBidCpm = defineAsyncComponent(() => import('./MaxBidCpm.vue'));
const IconMediaOwner = defineAsyncComponent(() => import('./MediaOwner.vue'));
const IconMediaType = defineAsyncComponent(() => import('./MediaType.vue'));
const IconMegaphone = defineAsyncComponent(() => import('./Megaphone.vue'));
const IconMenu = defineAsyncComponent(() => import('./Menu.vue'));
const IconMessage = defineAsyncComponent(() => import('./Message.vue'));
const IconMinus = defineAsyncComponent(() => import('./Minus.vue'));
const IconMissingDimension = defineAsyncComponent(() => import('./MissingDimension.vue'));
const IconMobilePhone = defineAsyncComponent(() => import('./MobilePhone.vue'));
const IconMobilePhoneVibrating = defineAsyncComponent(() => import('./MobilePhoneVibrating.vue'));
const IconMonitoring = defineAsyncComponent(() => import('./Monitoring.vue'));
const IconMore = defineAsyncComponent(() => import('./More.vue'));
const IconMovie = defineAsyncComponent(() => import('./Movie.vue'));
const IconNetwork = defineAsyncComponent(() => import('./Network.vue'));
const IconNext = defineAsyncComponent(() => import('./Next.vue'));
const IconNext2 = defineAsyncComponent(() => import('./Next2.vue'));
const IconNotVisible = defineAsyncComponent(() => import('./NotVisible.vue'));
const IconOrganization = defineAsyncComponent(() => import('./Organization.vue'));
const IconOrientationLandscape = defineAsyncComponent(() => import('./OrientationLandscape.vue'));
const IconOrientationPortrait = defineAsyncComponent(() => import('./OrientationPortrait.vue'));
const IconPacing = defineAsyncComponent(() => import('./Pacing.vue'));
const IconPackage = defineAsyncComponent(() => import('./Package.vue'));
const IconPassword = defineAsyncComponent(() => import('./Password.vue'));
const IconPassword2 = () => import('./Password2.vue');
const IconPause = defineAsyncComponent(() => import('./Pause.vue'));
const IconPause2 = defineAsyncComponent(() => import('./Pause2.vue'));
const IconPendingApproval = defineAsyncComponent(() => import('./PendingApproval.vue'));
const IconPin = defineAsyncComponent(() => import('./Pin.vue'));
const IconPin2 = defineAsyncComponent(() => import('./Pin2.vue'));
const IconPlan = defineAsyncComponent(() => import('./Plan.vue'));
const IconPlaneRight = defineAsyncComponent(() => import('./PlaneRight.vue'));
const IconPlaneTopRight = defineAsyncComponent(() => import('./PlaneTopRight.vue'));
const IconPlay = defineAsyncComponent(() => import('./Play.vue'));
const IconPlay2 = defineAsyncComponent(() => import('./Play2.vue'));
const IconPlayHexagon = defineAsyncComponent(() => import('./PlayHexagon.vue'));
const IconPollen = defineAsyncComponent(() => import('./Pollen.vue'));
const IconPolygon = defineAsyncComponent(() => import('./Polygon.vue'));
const IconPostalCode = defineAsyncComponent(() => import('./PostalCode.vue'));
const IconPrevious = defineAsyncComponent(() => import('./Previous.vue'));
const IconPrevious2 = defineAsyncComponent(() => import('./Previous2.vue'));
const IconPrivateDeal = defineAsyncComponent(() => import('./PrivateDeal.vue'));
const IconProfilePicture = defineAsyncComponent(() => import('./ProfilePicture.vue'));
const IconProgress = defineAsyncComponent(() => import('./Progress.vue'));
const IconPublish = defineAsyncComponent(() => import('./Publish.vue'));
const IconPublished = defineAsyncComponent(() => import('./Published.vue'));
const IconRadio = defineAsyncComponent(() => import('./Radio.vue'));
const IconRadius = defineAsyncComponent(() => import('./Radius.vue'));
const IconRandom = defineAsyncComponent(() => import('./Random.vue'));
const IconRankFirst = defineAsyncComponent(() => import('./RankFirst.vue'));
const IconRankSecond = defineAsyncComponent(() => import('./RankSecond.vue'));
const IconRankThird = defineAsyncComponent(() => import('./RankThird.vue'));
const IconRefresh = defineAsyncComponent(() => import('./Refresh.vue'));
const IconRegion = defineAsyncComponent(() => import('./Region.vue'));
const IconReject = defineAsyncComponent(() => import('./Reject.vue'));
const IconRemoveFromCart = defineAsyncComponent(() => import('./RemoveFromCart.vue'));
const IconReport = defineAsyncComponent(() => import('./Report.vue'));
const IconReportFormat = defineAsyncComponent(() => import('./ReportFormat.vue'));
const IconReset = defineAsyncComponent(() => import('./Reset.vue'));
const IconRestore = defineAsyncComponent(() => import('./Restore.vue'));
const IconRetire = defineAsyncComponent(() => import('./Retire.vue'));
const IconRevenue = defineAsyncComponent(() => import('./Revenue.vue'));
const IconRewind = defineAsyncComponent(() => import('./Rewind.vue'));
const IconRightArrow = defineAsyncComponent(() => import('./RightArrow.vue'));
const IconRightArrow2 = defineAsyncComponent(() => import('./RightArrow2.vue'));
const IconRowHandle = defineAsyncComponent(() => import('./RowHandle.vue'));
const IconSad = defineAsyncComponent(() => import('./Sad.vue'));
const IconSale = defineAsyncComponent(() => import('./Sale.vue'));
const IconSatellite = defineAsyncComponent(() => import('./Satellite.vue'));
const IconSave = defineAsyncComponent(() => import('./Save.vue'));
const IconScreen = defineAsyncComponent(() => import('./Screen.vue'));
const IconSearch = defineAsyncComponent(() => import('./Search.vue'));
const IconSectionCollapse = defineAsyncComponent(() => import('./SectionCollapse.vue'));
const IconSectionExpand = defineAsyncComponent(() => import('./SectionExpand.vue'));
const IconSelected = defineAsyncComponent(() => import('./Selected.vue'));
const IconSetting = defineAsyncComponent(() => import('./Setting.vue'));
const IconSettings2 = defineAsyncComponent(() => import('./Settings2.vue'));
const IconShare = defineAsyncComponent(() => import('./Share.vue'));
const IconSite = defineAsyncComponent(() => import('./Site.vue'));
const IconSlow = defineAsyncComponent(() => import('./Slow.vue'));
const IconSort = defineAsyncComponent(() => import('./Sort.vue'));
const IconSortAsc = defineAsyncComponent(() => import('./SortAsc.vue'));
const IconSortDesc = defineAsyncComponent(() => import('./SortDesc.vue'));
const IconSSP = defineAsyncComponent(() => import('./SSP.vue'));
const IconStart = defineAsyncComponent(() => import('./Start.vue'));
const IconStatus = defineAsyncComponent(() => import('./Status.vue'));
const IconStop = defineAsyncComponent(() => import('./Stop.vue'));
const IconSubmit = defineAsyncComponent(() => import('./Submit.vue'));
const IconSuccess = defineAsyncComponent(() => import('./Success.vue'));
const IconSummary = defineAsyncComponent(() => import('./Summary.vue'));
const IconSupply = defineAsyncComponent(() => import('./Supply.vue'));
const IconSync = defineAsyncComponent(() => import('./Sync.vue'));
const IconTag = defineAsyncComponent(() => import('./Tag.vue'));
const IconTargeting = defineAsyncComponent(() => import('./Targeting.vue'));
const IconThreeVerticalDots = defineAsyncComponent(() => import('./ThreeVerticalDots.vue'));
const IconTiles = defineAsyncComponent(() => import('./Tiles.vue'));
const IconTracking = defineAsyncComponent(() => import('./Tracking.vue'));
const IconTravelDestination = defineAsyncComponent(() => import('./TravelDestination.vue'));
const IconTriangleDown = defineAsyncComponent(() => import('./TriangleDown.vue'));
const IconTriangleUp = defineAsyncComponent(() => import('./TriangleUp.vue'));
const IconUngroup = defineAsyncComponent(() => import('./Ungroup.vue'));
const IconUnit = defineAsyncComponent(() => import('./Unit.vue'));
const IconUnitPack = defineAsyncComponent(() => import('./UnitPack.vue'));
const IconUnpublish = defineAsyncComponent(() => import('./Unpublish.vue'));
const IconUp = defineAsyncComponent(() => import('./Up.vue'));
const IconUpload = defineAsyncComponent(() => import('./Upload.vue'));
const IconUser = defineAsyncComponent(() => import('./User.vue'));
const IconUser2 = () => import('./User2.vue');
const IconUv = defineAsyncComponent(() => import('./UV.vue'));
const IconVerticalDots = defineAsyncComponent(() => import('./VerticalDots.vue'));
const IconVisible = defineAsyncComponent(() => import('./Visible.vue'));
const IconWarning = defineAsyncComponent(() => import('./Warning.vue'));
const IconWarningFilled = defineAsyncComponent(() => import('./WarningFilled.vue'));
const IconWarningHexagon = defineAsyncComponent(() => import('./WarningHexagon.vue'));
const IconWeather = defineAsyncComponent(() => import('./Weather.vue'));
const IconWin = defineAsyncComponent(() => import('./Win.vue'));
const IconX = defineAsyncComponent(() => import('./X.vue'));
const IconYieldManager = defineAsyncComponent(() => import('./YieldManager.vue'));
const IconYieldManagerConfig = defineAsyncComponent(() => import('./YieldManagerConfig.vue'));
const IconView = defineAsyncComponent(() => import('./View.vue'));

export {
  IconAccount,
  IconAction,
  IconAdd,
  IconAdd2,
  IconAddToCart,
  IconAdRequest,
  IconAdSpend,
  IconAdvancedReport,
  IconAdvertiser,
  IconAfter,
  IconAirplane,
  IconAirTravel,
  IconAlert,
  IconApplyAll,
  IconApprove,
  IconArrival,
  IconArrowDown,
  IconArrowUp,
  IconAuction,
  IconAudience,
  IconAudienceAudit,
  IconAudienceFile,
  IconAudienceGeofenceGroup,
  IconAudienceLogic,
  IconAudienceRule,
  IconAudit,
  IconAuditCreated,
  IconAuditDeleted,
  IconAuditUpdated,
  IconAutopilot,
  IconAvails,
  IconBadConnection,
  IconBefore,
  IconBudget,
  IconBudgetCap,
  IconBuy,
  IconBuyer,
  IconCadenceBuy,
  IconCalendar,
  IconCampaign,
  IconCancel,
  IconCart,
  IconChartArea,
  IconChartBar,
  IconChartCandlestick,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconCheck2,
  IconCheckAvailsResultFailure,
  IconCheckAvailsResultSuccess,
  IconCheckboxChecked,
  IconCheckboxUnchecked,
  IconCheckboxUndeterminated,
  IconChecked,
  IconCheckFat,
  IconCircle,
  IconCircleCheck,
  IconCircleX,
  IconCity,
  IconClock,
  IconClose,
  IconCo2,
  IconCollapse,
  IconCollapsed,
  IconCollapsed2,
  IconCollapseNavBar,
  IconColumns,
  IconCopy,
  IconCountry,
  IconCPM,
  IconCreative,
  IconCreativeType,
  IconCsvFile,
  IconCurator,
  IconCurrency,
  IconCustomField,
  IconDailyGoalCap,
  IconDashboard,
  IconDaypart,
  IconDeal,
  IconDelete,
  IconDemand,
  IconDeparture,
  IconDiscount,
  IconDisplayAndVideo,
  IconDooh,
  IconDown,
  IconDownload,
  IconDrag,
  IconDraw,
  IconDuplicate,
  IconEdit,
  IconEditable,
  IconEmail,
  IconEmail2,
  IconEmailAlert,
  IconEnlarge,
  IconError,
  IconErrorFilled,
  IconEstimatedCPM,
  IconEvent,
  IconExchange,
  IconExcluded,
  IconExitFullScreen,
  IconExpand,
  IconExpanded,
  IconExpanded2,
  IconExpandNavBar,
  IconExternalCreative,
  IconExternalEvent,
  IconEye,
  IconFallbackCreative,
  IconFast,
  IconFastForward,
  IconFees,
  IconFileCSV,
  IconFileSync,
  IconFileXLS,
  IconFilter,
  IconFilterFilled,
  IconFitIntoView,
  IconFlightArrival,
  IconFlightDeparture,
  IconFlowChart,
  IconForecast,
  IconFormula,
  IconFullScreen,
  IconGeofenceGroup,
  IconGood,
  IconGoodFilled,
  IconGroup,
  IconHeaderBidderPreset,
  IconHelp,
  IconHide,
  IconHierarchy,
  IconHigh,
  IconImpressions,
  IconImpressionsDelivered,
  IconInfinity,
  IconInfo,
  IconJourney,
  IconLanguage,
  IconLeaf,
  IconLegacy,
  IconLiftDashboard,
  IconLightBulb,
  IconLightning,
  IconLineItem,
  IconLink,
  IconList,
  IconLocation,
  IconLocation2,
  IconLock,
  IconLocked,
  IconLogout,
  IconLow,
  IconMagicWand,
  IconMailbox,
  IconMap,
  IconMargin,
  IconMarket,
  IconMarketplace,
  IconMarkup,
  IconMaster,
  IconMaxBidCpm,
  IconMediaOwner,
  IconMediaType,
  IconMegaphone,
  IconMenu,
  IconMessage,
  IconMinus,
  IconMissingDimension,
  IconMobilePhone,
  IconMobilePhoneVibrating,
  IconMonitoring,
  IconMore,
  IconMovie,
  IconNetwork,
  IconNext,
  IconNext2,
  IconNotVisible,
  IconOrganization,
  IconOrientationLandscape,
  IconOrientationPortrait,
  IconPacing,
  IconPackage,
  IconPassword,
  IconPassword2,
  IconPause,
  IconPause2,
  IconPendingApproval,
  IconPin,
  IconPin2,
  IconPlan,
  IconPlaneRight,
  IconPlaneTopRight,
  IconPlay,
  IconPlay2,
  IconPlayHexagon,
  IconPollen,
  IconPolygon,
  IconPostalCode,
  IconPrevious,
  IconPrevious2,
  IconPrivateDeal,
  IconProfilePicture,
  IconProgress,
  IconPublish,
  IconPublished,
  IconRadio,
  IconRadius,
  IconRandom,
  IconRankFirst,
  IconRankSecond,
  IconRankThird,
  IconRefresh,
  IconRegion,
  IconReject,
  IconRemoveFromCart,
  IconReport,
  IconReportFormat,
  IconReset,
  IconRestore,
  IconRetire,
  IconRevenue,
  IconRewind,
  IconRightArrow,
  IconRightArrow2,
  IconRowHandle,
  IconSad,
  IconSale,
  IconSatellite,
  IconSave,
  IconScreen,
  IconSearch,
  IconSectionCollapse,
  IconSectionExpand,
  IconSelected,
  IconSetting,
  IconSettings2,
  IconShare,
  IconSite,
  IconSlow,
  IconSort,
  IconSortAsc,
  IconSortDesc,
  IconSSP,
  IconStart,
  IconStatus,
  IconStop,
  IconSubmit,
  IconSuccess,
  IconSummary,
  IconSupply,
  IconSync,
  IconTag,
  IconTargeting,
  IconThreeVerticalDots,
  IconTiles,
  IconTracking,
  IconTravelDestination,
  IconTriangleDown,
  IconTriangleUp,
  IconUngroup,
  IconUnit,
  IconUnitPack,
  IconUnpublish,
  IconUp,
  IconUpload,
  IconUser,
  IconUser2,
  IconUv,
  IconVerticalDots,
  IconView,
  IconVisible,
  IconWarning,
  IconWarningFilled,
  IconWarningHexagon,
  IconWeather,
  IconWin,
  IconX,
  IconYieldManager,
  IconYieldManagerConfig,
};

export default {};
